import { COVARIATE_DATASET_TYPE_ENUM } from "@models/mood/covariates/dataset";

export enum TreeNodeType {
  GROUP = "GROUP",
  DATASET = "DATASET",
  MODEL = "MODEL"
}

export interface ITreeNode {
  label: string;
  node_order?: number;
  sort_by_name?: boolean;

  type: TreeNodeType;// "GROUP" | "DATASET" | "MODEL";
}

export interface GroupedTreeNode extends ITreeNode, IHasChildren {
  category_id: string;
  type: TreeNodeType.GROUP; //"GROUP";

  categories?: string[];
}

export interface GroupsTreeNode extends ITreeNode, IHasChildren {
  group_id: string;
  type: TreeNodeType.GROUP; //"GROUP";
  groups?: string[];
}

interface IHasChildren {
  children?: ITreeNode[];
}


export interface IDatasetTreeNode extends ITreeNode {
  type: TreeNodeType.DATASET//  "DATASET";
  data_type: "SINGLE" | "GROUP";
  file_type: "VECTOR" | "RASTER";

  dataset_id: string;
  metainfo_id?: string;

  original_dataset_type?: COVARIATE_DATASET_TYPE_ENUM;

  tooltip?: string;

  unvalidated?: boolean;
}

export interface IModelTreeNode extends ITreeNode, IHasChildren {
  type: TreeNodeType.MODEL// "MODEL";

  model_id: string;

  children?: IModelFileTreeNode[];
}

export interface SingleDatasetNode extends IDatasetTreeNode {
  data_type: "SINGLE";
  file_type: "VECTOR";
}

export interface GroupedDatasetNode extends IDatasetTreeNode, IHasChildren {
  data_type: "GROUP";

  children: IDatasetFileTreeNode[];
}

export interface IDatasetFileTreeNode extends IDatasetTreeNode {
  filekey: string;
}

export interface IModelFileTreeNode extends IModelTreeNode {
  filekey: string;
}
